export default "__VITE_ASSET__DqYnbeOR__"